import React from "react";
import styles from "../add-site.module.css";
import { Input } from "../../../../components/Shared/Forms";
import { formDataType } from "../AddSite";
import { PhoneInput } from "react-international-phone";

interface ClientDetailsProps {
  formData: formDataType;
  setFormData: React.Dispatch<React.SetStateAction<formDataType>>;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  fieldErrors?: { [key: string]: string };
}

export function ClientDetails({
  formData,
  setFormData,
  handleInputChange,
  fieldErrors,
}: ClientDetailsProps) {
  return (
    <div className={"my-4"}>
      <div className={styles["responsive-grid-2"]}>
        <Input
          name={"client_name"}
          label={"Client name"}
          value={formData.client_name}
          onChange={handleInputChange}
          error={fieldErrors?.client_name}
        />
        <Input
          name={"client_agent_name"}
          label={"Agent name"}
          value={formData.client_agent_name}
          onChange={handleInputChange}
          error={fieldErrors?.client_agent_name}
        />
      </div>
      <div className={styles["responsive-grid-2"]}>
        <div>
          <label className="block mb-2">Phone number</label>
          <PhoneInput
            defaultCountry="za"
            value={formData.client_agent_phone}
            name={"client_agent_phone"}
            onChange={e => {
              setFormData({
                ...formData,
                client_agent_phone: e || "",
              });
            }}
            inputStyle={{
              width: "100%",
              height: "50px",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              padding: "0.75rem",
              fontSize: "1rem",
              lineHeight: "1.5",
              backgroundColor: "#ffffff",
              outline: "none",
              transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
            }}
            countrySelectorStyleProps={{
              buttonStyle: {
                border: "1px solid #d1d5db",
                borderRadius: "6px 0 0 6px",
                backgroundColor: "#ffffff",
                padding: "0.75rem 0.5rem",
                height: "50px",
              },
            }}
            inputClassName="p-inputtext"
          />
        </div>
        <Input
          name={"client_agent_email"}
          label={"Agent email address"}
          value={formData.client_agent_email}
          onChange={handleInputChange}
          placeholder={"Example: john.doe@dsf.co.za"}
          type={"email"}
          error={fieldErrors?.client_agent_email}
        />
      </div>
    </div>
  );
}
